// Scroll-kohdan palautus takaisin-navigoinnissa. Sivu rekisteröityy luonnissa ja ilmoittaa, kun sen data on
// renderöity; routerin scrollBehavior odottaa sitä ennen kuin palauttaa tallennetun kohdan (muuten sivu on vielä
// matala ja kohta rajautuisi nollaan). Rekisteröinti sidotaan fullPathiin, ja aikakatkaisu estää jäämästä odottamaan.
// listQuery-mixin rekisteröi listat automaattisesti.

let current = null;

export function registerScrollMemory(fullPath) {
  let resolve;
  const registration = { fullPath, promise: new Promise(r => (resolve = r)) };
  current = registration;
  return {
    markDataLoaded: () => resolve(),
    // Uusi sivu rekisteröityy ennen kuin vanha tuhotaan, joten poistetaan vain oma rekisteröinti
    unregister: () => {
      if (current === registration) current = null;
    },
  };
}

export function waitForScrollMemory(fullPath, timeoutMs = 2000) {
  const registration = current;
  if (!registration || registration.fullPath !== fullPath) return Promise.resolve();
  return Promise.race([registration.promise, new Promise(r => setTimeout(r, timeoutMs))]);
}
